import type { TenantRole } from "@shared-domain/auth-service/contract";
import { TENANT_ROLE_LABELS, tenantRoleLabel } from "@shared-domain/unizo/tenantRoleLabels";

/**
 * PRODUCT_DEV-1235: テナントの役割の説明（ユーザー一覧・ユーザー詳細・新規作成で同じものを出す）。
 * 並びは弱い順。値の正本は `@shared-domain/auth-service/contract` の `TENANT_ROLES`、
 * 呼び名の正本は `@shared-domain/unizo/tenantRoleLabels`（データ出力の役割の列も同じ呼び名・PRODUCT_DEV-1332）。
 * できることの正本は `@shared-domain/unizo/permissions` の表で、説明はその要約。
 */
export const TENANT_ROLE_OPTIONS: readonly {
  value: TenantRole;
  label: string;
  description: string;
}[] = [
  { value: "viewer", label: TENANT_ROLE_LABELS.viewer, description: "記録を見るだけ" },
  { value: "member", label: TENANT_ROLE_LABELS.member, description: "自分の記録を作る・直す" },
  {
    value: "power",
    label: TENANT_ROLE_LABELS.power,
    description:
      "メンバーに加えて、記録を全件見る・他人の記録を直す・データ出力・部署と顧客マスタ・辞書・配信の設定",
  },
  {
    value: "admin",
    label: TENANT_ROLE_LABELS.admin,
    description:
      "パワーユーザーに加えて、ユーザー管理・セキュリティ設定・記録の完全削除",
  },
];

/** 役割の呼び名。知らない値はメンバーとして見せる（古い画面が新しい値を受け取ったときと同じ倒し方）。 */
export { tenantRoleLabel };
